import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
export function getReportRhumbConfig(successMarkerName, errorMarkerName, Component = NavMarker) {
  const config = {
    renderSuccessMarker: () => /*#__PURE__*/_jsx(Component, {
      name: successMarkerName
    })
  };
  if (errorMarkerName) {
    config.errorMarkerName = () => /*#__PURE__*/_jsx(Component, {
      name: errorMarkerName
    });
  }
  return config;
}